import React from 'react';
import { useStaticQuery, Link, graphql } from 'gatsby';

export default function Footer() {
	const {
		site: { siteMetadata },
		mdx: legalPage,
	} = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
				}
			}
			mdx(
				fields: {
					collection: { eq: "pages" }
					page: { eq: "legal" }
					block: { eq: null }
				}
			) {
				frontmatter {
					title
				}
			}
		}
	`);

	return (
		<footer className="footer">
			<div className="container">
				<div className="row">
					<div className="col-xs-12 col-sm-4 col-partners"></div>
					<div className="col-xs-12 col-sm-4 col-sm-push-4 col-contact">
						<h3>Grenoble</h3>
						<p>
							<a
								href="http://maps.google.com/?q=ELEARNIS"
								rel="noopener noreferrer"
								className="address"
							>
								8 chemin du Pré Carré 38240 Meylan - FRANCE
							</a>
						</p>
						<p>
							<a href="tel:+33458003868" className="telephone">
								+33 (0)4 58 00 38 68
							</a>
						</p>
						<p>
							<a
								href="mail&#116;o&#58;&#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#101;&#108;&#101;&#97;&#114;&#110;&#105;&#115;&#46;&#102;&#114;"
								className="email"
							>
								&#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#101;&#108;&#101;&#97;&#114;&#110;&#105;&#115;&#46;&#102;&#114;
							</a>
						</p>
					</div>
					<div className="col-xs-12 col-sm-4 col-sm-pull-4 col-copyright">
						<div className="social">
							<a
								href="http://maps.google.com/?q=ELEARNIS"
								rel="noopener noreferrer"
								className="btn btn-lg"
							>
								<i className="fa fa-map-marker"></i>
								<span className="sr-only">google maps</span>
							</a>
							<a
								href="https://www.linkedin.com/company/2376894"
								rel="noopener noreferrer"
								className="btn btn-lg"
							>
								<i className="fa fa-linkedin"></i>
								<span className="sr-only">linkedin</span>
							</a>
							<a
								href="https://twitter.com/elearnis"
								rel="noopener noreferrer"
								className="btn btn-lg"
							>
								<i className="fa fa-twitter"></i>
								<span className="sr-only">twitter</span>
							</a>
						</div>

						<section className="signature">
							<span className="copyright">
								&copy; {siteMetadata.title}
							</span>
							{' - '}
							<Link
								to={
									process.env.GATSBY_PAGES_LEGAL_SLUG ||
									'/legal/'
								}
							>
								{legalPage.frontmatter.title}
							</Link>
						</section>
					</div>
				</div>
			</div>
		</footer>
	);
}
